// 生源池-不可编辑信息，即非自定义信息
export const notEditableKeys: string[] = [
  'name',
  'graduate',
  'phone',
  'registed_at',
  'gender',
  'status',
  'avatar',
  'activity_names',
  'account',
  'usin',
  'idcard',
  'idcard_type',
  'email',
  'guardians.0.name',
  'guardians.0.pupil_type',
  'guardians.0.phone',
  'guardians.1.name',
  'guardians.1.pupil_type',
  'guardians.1.phone',
]

// 生源池-仅支持精确筛选的keys
export const accurateSearchKeys: string[] = [
  'gender',
  'status',
  'idcard_type',
  'idcard',
  'email',
  'graduate',
]

export const guardiansFixedKeys = [
  'guardians.0.pupil_type',
  'guardians.1.pupil_type',
]

export const selectNewKey: { [key: string]: (val: string) => string } = {
  'guardians.0.name': () => 'guardians.0.name',
  'guardians.1.name': () => 'guardians.1.name',
  'guardians.0.phone': (val: string) =>
    /，|,/.test(val) ? 'guardians.0.phoneIn' : 'guardians.0.phone',
  'guardians.1.phone': (val: string) =>
    /，|,/.test(val) ? 'guardians.1.phoneIn' : 'guardians.1.phone',
}
